import styled from '@emotion/styled';
import { clickEventDL, dlProductUpdate } from 'dw-global/apps/dataLayer';
import { FormatPhone, useProfile } from 'dw-us-ui';
import {
  BottleZoom,
  BrandUtil,
  CreateCaseSummary,
  DescriptionTab,
  EmotionBreakpoint,
  FlavorProfiles,
  FoodPairings,
  LoadingIcon,
  ProductHeadline,
  SingleBottleRating,
  useContentful,
  useProductContentful,
} from 'dw-us-ui/src/bundles/product-bundle';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useContentfulClient } from '../../hooks';
import SlickCaseContents from '../../components/Slick/SlickCaseContents';

import * as Icons from '../../components/Icons/SvgIcons';

const StyledContainer = styled.div`
  .inner-container {
    ${EmotionBreakpoint('desktop')} {
      width: 970px;
    }
    margin-left: auto;
    margin-right: auto;
  }
  @media print {
    display: block;
  }
`;

const TastingNotesContainer = styled.div`

  .socials-container {
    width: 30%;

    .law & {
      width: 40%;
    }
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    ${EmotionBreakpoint('mobile')} {
      width: 100%;
      align-items: flex-start;
    }
    .text-right {
      text-align: start
    }
  }

  .product-title {
    .law & {
      font-family: 'Open Sans'
    }
  }

  .product-title > div:first-child {
    width: 100%;

    .osw & {
      text-align: center;

      h2 {
        text-align: left;
        ${EmotionBreakpoint('mobile')} {
          text-align: center !important;
        }
      }
    }
  }

  .ratings-container {
    .osw & {
      width: 100%;
      display: flex;
      flex-direction: column-reverse;
      align-items: flex-end;
      ${EmotionBreakpoint('mobile')} {
        align-items: center;
        justify-content: center;
      }
    }

    .bv-container {
      ${EmotionBreakpoint('mobile')} {
        margin-left: 3rem;
      }
      margin-top: 15px;
      .bv_ratings_summary {
        padding-right: 0 !important;
      }
      .bv_avgRating_component_container {
        display: none !important;
      }
      .bv_numReviews_text {
        display: none !important;
      }
      .bv_button_component_container {
        display: none !important;
        padding-right: 0 !important;
      }
    }
  }

  .hide-content-on-osw {
    .osw & {
      display: none;
    }
  }

  .beyond-title-print {
    position: relative;
    .osw & {
      width: 100%;
      background: #890419;

      .osw-print-desktop {
        position: absolute;
        top: 20%;
        right: 1rem;
        display: flex;
        align-items: center;
        color: white;
        ul {
          display: flex;
          align-items: center;
          li {
            margin-right: 7px;
          }
          li.osw-mail {
            padding-top: 10px;
          }
        }
        ${EmotionBreakpoint('mobile')} {
          display: none;
        }
      }

      h2,
      .h1 {
        color: #fff;
        text-align: center;
        font-family: 'Neue-haas-grotesk', "Arial", sans-serif;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize !important;
      }
    }
  }
  .web-headline{
    .osw & {
      font-weight: bold;
      font-size: 1.8em;
      line-height: 28px;
      padding-top: 30px;
      padding-left: 0px !important;
      padding-bottom: 0px !important;
    }
  }
  min-height: 380px;
  .osw & {
    background: #f8f8f8;
    .wine-details {
      padding-left: 58px;
      ${EmotionBreakpoint('mobile')} {
        width: 100%;
        padding-left: 20px;
      }
    }

    .flavorProfilesContainer {
      width: 475px;
      padding-left: 0 !important;
     ${EmotionBreakpoint('mobile')} { 
        width: 285px;
      }
       ${EmotionBreakpoint('tablet')} {
        width:300px;
       }

    }
    .wine-description {
      padding-right: 0px !important;
  
       ${EmotionBreakpoint('mobile')} {
        padding-left: 0px !important;
       }
    }
  }
  ${EmotionBreakpoint('notMobile')} {
    .img-block {
      margin-top: -15px;


      .osw & {
        margin-top: 7px;
        img {
          height: 354px;
          margin-left: 200px;
        }

        .text-zoom{
              img {
              height: unset;
              padding-left: unset;
              margin-left: 16.5em;
            }
          }
      }
    }
  }
  ${EmotionBreakpoint('tablet')} {
    .img-block {
      margin-top: -15px;

      .osw & {
        margin-top: 7px;
        img {
          height: 354px;
          margin-left: 129px;
        }
        .text-zoom{
            img {
              height: unset;
              padding-left: unset;
              margin-left: 11.5em;
            }
        }
      }
    }
  }
  }
  ${EmotionBreakpoint('mobile')} {
     .img-block {
      margin-top: -15px;

      .osw & {
        margin-top: 7px;
        padding-bottom: 35px;
        img {
          height: 354px;
        }
        .text-zoom{
            img {
              height: unset;
            }
        }
      }
    }
  }
  }
    width: 100%;
    background: #f8f5ef;
    .wsj & {
      background: #f1f1f1;
    }
    .title {
      text-align: center;
      width: 100%;
      h1,
      .h1 {
        padding: 12px 24px;
        line-height: 30px;
        background-color: ${({ theme }) => theme.colors.highlight};
        font-family: ${({ theme }) => theme.fonts.special};
        color: #fff !important;
        display: inline-block;
        text-transform: uppercase;
        font-size: 24px;

        .wsj & {
          text-transform: none;
          font-weight: bold;
        }
        .npr & {
          background: #d62021;
        }
      }
    }
    margin-bottom: 30px;
    padding-bottom: 20px;
    overflow-x: hidden;
    text-align: left;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .source-image {
      // mix-blend-mode: multiply;
    }

    .preview-attributes-row {
      padding: 15px 0;
      text-align: left;
      svg {
        vertical-align: text-bottom;
      }
      span {
        padding-left: 5px;
      }
      ${EmotionBreakpoint('mobile')} {
        padding: 5px 0;
      }
    }
    ${EmotionBreakpoint('mobile')} {
      h2 {
        margin-top: 15px;
      }
    }
    .wine-description {
      padding: 0 40px;
      ${EmotionBreakpoint('mobile')} {
        padding: 0px;
      }
      span {
        p {
          margin: 10px 0;
        }
      }
    }
    .osw & {
      .osw-col{
        padding-top: 43px;
         ${EmotionBreakpoint('mobile')} {
          padding-top: 0;
         }  
      
      }
    }
    .tab-component {
      margin-bottom: 20px;
      text-align: left;

    }
    .hr-line {
      border-top: 1px solid #cacaca;
      margin: 10px 40px;

      .osw & {
        padding-top: 43px;
         ${EmotionBreakpoint('mobile')} {
          padding-top: 0;
         }
        
      }
      ${EmotionBreakpoint('mobile')} {
        margin: 0;
      }
    }

    .product-reviews-link {
      display: none;
    }
    .write-review-link {
      border-left: none !important;
    }
    .pad20 {
      padding: 20px;
      .web-headline,
      .product-name {
        text-align: left;
      }
      ${EmotionBreakpoint('mobile')} {
        padding: 0 15px;
        .osw & {
          padding-left: 0;
          padding-bottom: 20px;
        }
      }
      div {
        text-align: right;

        .osw & {
          margin-top: -57px;
          color: #fff;
          font-family: Roboto;
          font-size: 14px;
          font-style: normal;
          line-height: 18.2px;
          strong,
          b {
            font-weight: 400 !important;
            padding-right: 12px;
            ${EmotionBreakpoint('mobile')} {
              color: #222;
            }
          }
          ${EmotionBreakpoint('mobile')} {
            padding-top: 15px;
            padding-right: 0;
            margin-top: 0;
            display: flex;
            justify-content: center;
          }
        }
        ${EmotionBreakpoint('mobile')} {
          text-align: left;
        }
      }
    }
    .hide-page {
      display: none;

    }
    .web-headline {
      a {
        color: inherit;
      }
    }

    ul.share-links {
      display: inline-block;
      li {
        display: inline-block;
        margin: 0 5px;
        cursor: pointer;
      }
      span {
        font-size: 18px;
      }
      .print-icon {
        vertical-align: middle;
      }
      .osw & {
        ${EmotionBreakpoint('mobile')} {
          li > span > img {
            height: 16px;
            width: 16px;
          }
        }
      }
    }
  }
  .icons {
    cursor: pointer;
  }
  .tasting-notes-image-section {
    div {
      .osw & {
        border-radius: 4px;
        overflow: hidden;
        margin: 4px;
      }
    }
    ${EmotionBreakpoint('notMobile')} {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .image-section {
      ${EmotionBreakpoint('mobile')} {
        width: 50%;
        display: inline-block;
        .osw & {
          width: 47%;
        }
      }
    }
    .image-section.text-right {
      ${EmotionBreakpoint('notMobile')} {
        margin-right: 15px;
      }
    }
  }
  .quote-section-osw {
    padding: 40px;
    .osw & {
      padding: 17px 24px 11px 24px;
      display: flex;
      justify-content: space-around;
    }
  }
  .quote-section {
    background: #203c5d;
    padding: 15px;
    color: #fff;
    .law & {
      width: 300px;
      height: 300px;
    }
    .osw & {
      margin-left: 15px;
      width: 300px;
      height: 300px;
      text-align: left;
      ${EmotionBreakpoint('mobile')} {
        margin: 0 !important;
        width: auto;
        height: auto;
      }
    }
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;
    .wsj &,
    .npr & {
      margin-left: 15px;
      width: 275px;
      height: 275px;
    }
    ${EmotionBreakpoint('tablet')} {
      margin-left: 15px;
      .wsj &,
      .npr & {
        width: 215px;
        height: 215px;
      }
      h2 {
        font-size: 1.3em;
      }
      .law & {
        width: 205px;
        height: 205px;

        h2 {
          font-size: 1.2em;
        }
      }
    }
    ${EmotionBreakpoint('mobile')} {
      .law &,
      .wsj &,
      .npr & {
        height: 175px;
        width: 100%;
        margin-left: 0 !important;
      }

      h2 {
        margin-top: 0;
      }
    }
  }
  .bottle-quote-source {
    margin-top: 15px;
  }
  .js-default-tasting-note-image-handler {
    .wsj &,
    .npr & {
      width: 275px;
      height: 275px;
    }
    .law & {
      height: 300px;
      width: 300px;
    }
    ${EmotionBreakpoint('tablet')} {
      .wsj &,
      .npr & {
        width: 215px;
        height: 215px;
      }
      .law & {
        width: 205px;
        height: 205px;
      }
    }
    ${EmotionBreakpoint('mobile')} {
      .law &,
      .wsj &,
      .npr & {
        margin-top: 10px;
        width: 160px;
        height: 150px;
      }
    }
  }
`;

const BeyondTheLabelMixed = ({ itemCode }) => {
  const profile = useProfile();

  const initialState = {
    addOnItemCode: '',
    addOnPromoCode: '',
  };
  const [addOnDetails, setAddOnDetails] = useState(initialState);

  async function fetchHtml() {
    if (addOnDetails?.addOnPromoCode) {
      setHtmlFileString(await (await fetch(addOnDetails?.addOnPromoCode)).text());
    }
  }

  useEffect(() => {
    let pdpItemCode = document.querySelector('#pdp_itemcode');
    let pdpPromoCode = document.querySelector('#pdp_promo_html');
    setAddOnDetails({
      ...addOnDetails,
      addOnItemCode: pdpItemCode && pdpItemCode.value,
      addOnPromoCode: pdpPromoCode && pdpPromoCode.value,
    });
  }, []);

  useEffect(() => {
    fetchHtml();
  }, [addOnDetails]);

  let gaCategory = 'Mixed_Case_Product_Page';

  let { tag: brandTag, url: brandUrl, logo } = BrandUtil.content(BrandUtil.getBrand());

  const BeyondLabelItem = styled.div`
    .osw & {
      &.include-right-margin {
        margin-right: 1rem;
      }
    }
  `;

  const [htmlFileString, setHtmlFileString] = useState();
  const [mixedCaseState, setMixedCaseState] = useState({
    apiResponse: false,
    apiError: false,
    productDetails: false,
    caseContents: [],
    caseSummary: false,
    showSummary: false,
    activeSection: false,
    currentProductIndex: false,
    foodPairings: [],
    productConfig: {},
    lawFlag: false,
  });
  const [product, setProduct] = useState([]);
  const [flavorProfile, setFlavorProfile] = useState();
  const [userPhoneNumber, setUserPhoneNumber] = useState('');
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const contentfulOptions = {
    spaceId: 'k1ni6e3k3b2n',
    productionToken: '0090c721437fa809001de135b0bc66ac81c9598f2092b9d513f693dd70d5f781',
    entryId: '3qKlCz35HWAWk2SsWIEG6w',
    includeValue: 1,
    queryObject: {
      contentType: 'foodPairing2',
    },
  };

  const { response, error } = useContentful(contentfulOptions);
  const contentfulClient = useContentfulClient({
    space: 'k1ni6e3k3b2n',
    accessToken: '0090c721437fa809001de135b0bc66ac81c9598f2092b9d513f693dd70d5f781',
    host: 'https://cdn.contentful.com/spaces/k1ni6e3k3b2n/environments/master/entries',
    environment: 'master',
  });

  const handleResize = () => {
    if (window.innerWidth < 768) setIsMobileView(true);
    else setIsMobileView(false);
  };

  useEffect(() => {
    if (response) {
      setMixedCaseState(prevState => {
        return {
          ...prevState,
          foodPairings: response?.fields?.foodPairingsConfig?.foodPairingDetails,
        };
      });
    }
    if (error) {
      setMixedCaseState(prevState => {
        return {
          ...prevState,
          foodPairings: [],
        };
      });
    }
  }, [response, error]);

  const { productConfig } = useProductContentful(itemCode);

  useEffect(() => {
    if (productConfig) {
      setMixedCaseState(prevState => {
        return {
          ...prevState,
          productConfig,
        };
      });
    }
  }, [productConfig]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    setLawFlag();
    getItemDetails();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let userInformation = profile?.userInformation?.trustedDetails?.billingAddress;
    if (userInformation?.phoneNumber) {
      let userPhone = userInformation?.phoneNumber;
      setUserPhoneNumber(FormatPhone(userPhone));
    }
  }, [profile]);

  useEffect(() => {
    if (typeof mixedCaseState.currentProductIndex !== 'number') return;
    const index = mixedCaseState.currentProductIndex;
    const caseContents = mixedCaseState.caseContents?.filter(item => {
      return item.skuItemCode.indexOf('LT') === -1 && item.skuItemCode.indexOf('SB') === -1;
    });
    setFlavorProfile(mixedCaseState.flavorProfiles[index]);
    setProduct(caseContents[index].referencedProduct);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mixedCaseState.currentProductIndex]);

  /*
    Adjust AutoAffix component height on scroll for law rebrand
  */
  const setLawFlag = () => {
    let bool = !!document.getElementsByClassName('law').length;

    setMixedCaseState(prevState => {
      return {
        ...prevState,
        lawFlag: bool,
      };
    });
  };

  const handleProductTransition = (activeSection, product) => {
    setMixedCaseState(prevState => {
      return {
        ...prevState,
        currentProductIndex: activeSection,
      };
    });
    const action = 'caseCarousel';
    clickEventDL(action, {
      clickLocation: 'wine case wines',
      clickName: 'wine case carousel click',
      clickAction: 'switch wine',
      clickText: `${product ? product.name : ''}`,
      clickDescription: `pdp:case carousel click`,
    });
  };

  const getQuote = text => {
    let quote = product?.accolades?.find(val => val.accoladeCategoryText?.toLowerCase() === 'quote');

    return quote ? quote[text] : null;
  };

  /*
    Get Product Details From Product API
   */
  const getItemDetails = () => {
    let path = '/api/product/item/' + itemCode;

    fetch(path, {
      method: 'get',
    })
      .then(res => res.json())
      .then(data => {
        setMixedCaseState(prevState => {
          return {
            ...prevState,
            productDetails: data.response,
            apiResponse: true,
            isPrePackedItem: data?.response?.vintage === '1950',
          };
        });
        dlProductUpdate(data.response);
      })
      .catch(() => {
        setMixedCaseState(prevState => {
          return {
            ...prevState,
            apiError: true,
          };
        });
      });
  };

  useEffect(() => {
    if (mixedCaseState?.productDetails?.name) {
      let path = '/api/product/case/' + itemCode;

      fetch(path, {
        method: 'get',
      })
        .then(res => res.json())
        .then(item => {
          // contentProducts can include LT (for case literature or print outs)
          let caseContents = item.response.contentProducts.filter(
            item => item.skuItemCode.indexOf('LT') === -1 && item.skuItemCode.indexOf('SB') === -1,
          );
          let productArr = [];
          // Create a new array in the format that is needed for the create case summary function
          caseContents.forEach(obj => {
            let data = obj.referencedProduct;
            let quantity = obj.quantity;
            let product = {
              product: data,
            };
            for (var i = 0; i < quantity; i++) {
              productArr.push(product);
            }
          });

          //Calculate Case Summary
          let caseSummary = CreateCaseSummary(productArr);

          return { caseContents, caseSummary };
        })
        .then(({ caseContents, caseSummary }) => {
          return getAllFlavorProfiles(caseContents).then(flavorProfiles => {
            return {
              flavorProfiles,
              caseContents,
              caseSummary,
            };
          });
        })
        .then(({ flavorProfiles, caseContents, caseSummary }) => {
          setMixedCaseState(prevState => ({
            ...prevState,
            flavorProfiles,
            caseContents,
            caseSummary,
            currentProductIndex: 0,
          }));
        })
        .catch(() => {
          // Both the caseContents and caseSummary states will stay false
          setMixedCaseState(prevState => {
            return {
              ...prevState,
              caseContents: [],
              caseSummary: false,
              apiError: true,
            };
          });
        });
    }
  }, [mixedCaseState.productDetails]);

  const socialPopup = platform => {
    switch (platform) {
      case 'facebook':
        window.open(
          `http://www.facebook.com/sharer.php?u=${location.origin}/product/` + product.itemCode,
          'popup',
          'width=800,height=600',
        );
        break;
      case 'twitter':
        window.open(
          `https://twitter.com/intent/tweet?url=${location.origin}/product/` + product.itemCode,
          'popup',
          'width=800,height=600',
        );
        break;
    }
  };

  const isMysteryCase = () => {
    let name = mixedCaseState.productDetails.name || 'none';
    return name.toLowerCase().includes('mystery');
  };

  const onProductClick = e => {
    e.preventDefault();
    location.href = `/product/${product.name?.replaceAll(' ', '-')}-${product.vintage}/${product.itemCode}`;
  };

  const getAllFlavorProfiles = async caseContents => {
    const itemCodes = caseContents.map(item => item.referencedProduct.itemCode);

    let queryObject = {
      content_type: 'product',
      'fields.itemCode[in]': itemCodes.join(','),
    };

    try {
      const flavorProfileData = await contentfulClient.getEntries(queryObject);

      const flavorProfilesByItemCode = flavorProfileData.items.reduce((acc, item) => {
        acc[item.fields.itemCode] = item.fields?.flavorProfileContent?.fields?.content ?? '';
        return acc;
      }, {});

      return await caseContents.map(bottle => flavorProfilesByItemCode[bottle.referencedProduct.itemCode]);
    } catch (contentfulError) {
      console.error('contentfulError', contentfulError);
      throw contentfulError;
    }
  };

  const productDataMap = [
    product?.styleName,
    product?.countryName,
    product?.grapeName,
    product?.alcoholPercent,
    product?.drinkCharacteristics?.organic,
    product?.bottleSize,
    product?.vintage,
  ].filter(Boolean);

  const indexOfProductCountry = productDataMap.indexOf(product?.countryName);
  const indexOfProductGrape = productDataMap.indexOf(product?.grapeName);
  const indexOfProductAlcohol = productDataMap.indexOf(product?.alcoholPercent);
  const indexOfProductOrganic = productDataMap.indexOf(product?.drinkCharacteristics?.organic);
  const indexOfProductBottleSize = productDataMap.indexOf(product?.bottleSize);
  const indexOfProductVintage = productDataMap.indexOf(product?.vintage);

  const isOSW = brandTag.toLowerCase() === 'osw';

  if (!mixedCaseState.apiResponse) {
    return <LoadingIcon />;
  } else if (mixedCaseState.apiError) {
    return (
      <div className="col-xs-12 text-center no-pad">
        <p className="alert alert-warning">
          Sorry, it looks like something went wrong. Please refresh your browser or try your search again.
        </p>
      </div>
    );
  }

  let isAdvent = product?.itemCode?.substr(-2) == 50 && !product?.itemCode?.match('/^[a-z]+$/i');

  const PrintAndSocials = ({ includeTopMargin, invertColors }) => {
    return (
      <div className="text-right" style={{ marginTop: includeTopMargin ? '10px' : 0 }}>
        <span>
          {brandTag === 'osw' ? (
            <strong
              style={{
                fontSize: isMobileView ? '14px' : '20px',
                marginRight: '10px',
              }}
            >
              Print / Share
            </strong>
          ) : (
            <span>Print / Share:</span>
          )}
        </span>
        <ul className="share-links">
          <li>
            <span
              className="print-icon default-view"
              onClick={() => {
                const action = 'print';
                clickEventDL(action, {
                  clickLocation: 'product page beyond the label',
                  clickName: 'print wine label',
                  clickAction: 'beyond label overlay',
                  clickText: 'print',
                  clickDescription: `pdp:print:${product?.itemCode}`,
                });
                window.print();
              }}
              role="presentation"
            >
              {brandTag === 'osw' ? (
                <img
                  src={isMobile ? '/images/us/osw/common/faq/print.svg' : '/images/us/osw/common/icons/btl-print.svg'}
                  alt="print"
                />
              ) : (
                <Icons.PrintIcon />
              )}
            </span>
          </li>
          <li>
            <span role="presentation" onClick={() => socialPopup('facebook')}>
              <img
                alt="facebook"
                src={
                  brandTag === 'osw'
                    ? isMobile
                      ? '/images/us/osw/common/icons/fb-black-social.svg'
                      : '/images/us/osw/common/icons/btl-facebook.svg'
                    : `/images/us/common/icons/${brandTag}/facebook-square-brands.svg`
                }
                height="16px"
                width="15px"
              />
            </span>
          </li>
          <li>
            <span role="presentation" onClick={() => socialPopup('twitter')}>
              <img
                alt="twitter"
                src={
                  brandTag === 'osw'
                    ? isMobile
                      ? '/images/us/osw/common/icons/x-black-social.svg'
                      : '/images/us/osw/common/icons/btl-twitter.svg'
                    : `/images/us/common/icons/${brandTag}/twitter-square-brands.svg`
                }
                height="16px"
                width="15px"
              />
            </span>
          </li>
          <li>
            <a
              href={`mailto: ?subject=I thought you may be interested in this &body=${product.name} %0D%0A ${location.host}/product/${product.itemCode}`}
            >
              {brandTag === 'osw' ? (
                <img
                  style={{
                    height: '16px',
                    width: '16px',
                    verticalAlign: 'top',
                    marginTop: isMobileView ? '3px' : 0,
                  }}
                  src={
                    isMobile
                      ? '/images/us/osw/common/icons/email-icon.svg'
                      : '/images/us/osw/common/icons/btl-envelope.svg'
                  }
                  alt="emial"
                />
              ) : (
                <span className="fa fa-envelope-o icons"></span>
              )}
            </a>
          </li>
        </ul>
      </div>
    );
  };

  return (
    <StyledContainer id="vp-mixed-beyond-the-label col-xs-12">
      <div className="inner-container">
        {mixedCaseState?.productDetails?.subProductType === 'Z098' ||
        !mixedCaseState?.caseContents?.length ||
        isAdvent ||
        isMysteryCase() ? null : (
          <>
            <br />
            <h2 className="text-left case-contents">Case Contents</h2>
            <br />
            <SlickCaseContents
              onProductTransition={handleProductTransition}
              caseContents={mixedCaseState.caseContents}
            />
            <TastingNotesContainer>
              <div className="title">
                <div className="text-center">
                  <img src={`${logo}`} className="hide-page" width={'198px'} alt="logo" />
                </div>
                <div className="beyond-title-print">
                  <h2 className="h1">Beyond the Label</h2>

                  {brandTag === 'osw' ? (
                    <div className="osw-print-desktop">
                      <span style={{ marginRight: '15px' }}>
                        <strong>Print / Share</strong>
                      </span>
                      <ul>
                        <li>
                          <span
                            onClick={() => {
                              const action = 'print';
                              clickEventDL(action, {
                                clickLocation: 'product page beyond the label',
                                clickName: 'print wine label',
                                clickAction: 'beyond label overlay',
                                clickText: 'print',
                                clickDescription: `pdp:print:${product?.itemCode}`,
                              });
                              window.print();
                            }}
                            role="presentation"
                          >
                            <img
                              src={
                                isMobile
                                  ? '/images/us/osw/common/faq/print.svg'
                                  : '/images/us/osw/common/icons/btl-print.svg'
                              }
                              alt="print"
                            />
                          </span>
                        </li>
                        <li>
                          <span role="presentation" onClick={() => socialPopup('facebook')}>
                            <img
                              alt="facebook"
                              src={
                                isMobile
                                  ? '/images/us/osw/common/icons/fb-black-social.svg'
                                  : '/images/us/osw/common/icons/btl-facebook.svg'
                              }
                              height="16px"
                              width="15px"
                            />
                          </span>
                        </li>
                        <li>
                          <span role="presentation" onClick={() => socialPopup('twitter')}>
                            <img
                              alt="twitter"
                              src={
                                isMobile
                                  ? '/images/us/osw/common/icons/x-black-social.svg'
                                  : '/images/us/osw/common/icons/btl-twitter.svg'
                              }
                              height="16px"
                              width="15px"
                            />
                          </span>
                        </li>
                        <li className="osw-mail">
                          <a
                            href={`mailto: ?subject=I thought you may be interested in this &body=${product.name} %0D%0A ${location.host}/product/${product.itemCode}`}
                          >
                            <img
                              style={{
                                height: '16px',
                                width: '16px',
                                verticalAlign: 'top',
                              }}
                              src={
                                isMobile
                                  ? '/images/us/osw/common/icons/email-icon.svg'
                                  : '/images/us/osw/common/icons/btl-envelope.svg'
                              }
                              alt="email"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="col-sm-12 col-xs-12" style={{ marginBottom: '20px' }}>
                <div
                  className="col-xs-12 product-title"
                  style={{
                    display: 'flex',
                    flexDirection: isMobileView ? 'column' : 'row',
                    alignItems: isMobileView ? 'flex-start' : 'center',
                    justifyContent: 'space-between',
                    borderBottom: brandTag.toLowerCase() === 'osw' ? '1px solid #222' : 'none !important',
                    paddingBottom: brandTag.toLowerCase() === 'osw' ? (isMobileView ? '10px' : 0) : 0,
                  }}
                >
                  <ProductHeadline
                    productDetails={product}
                    onProductClick={onProductClick}
                    qvEnabled={true}
                    showDescriptionInline
                  />

                  {brandTag.toLowerCase() !== 'osw' ? (
                    <div className="socials-container">
                      {brandTag.toLowerCase() === 'wsj' || brandTag.toLowerCase() === 'law' ? (
                        <div className="bv-container">
                          <div data-bv-show="rating_summary" data-bv-product-id={product?.itemCode}></div>
                        </div>
                      ) : (
                        <SingleBottleRating
                          className={`${isMobileView ? '' : 'text-right'}`}
                          ratingDetails={product.ratingDetails}
                          itemCode={product.itemCode}
                          containerClasses={'hide-content-on-osw'}
                        />
                      )}
                      <PrintAndSocials />
                    </div>
                  ) : null}
                </div>

                <div className={`col-sm-5 col-xs-12 ratings-container ${brandTag !== 'osw' ? 'pad20' : ''}`}>
                  {brandTag === 'osw' ? (
                    <div className="bv-container">
                      <div data-bv-show="rating_summary" data-bv-product-id={product?.itemCode}></div>
                    </div>
                  ) : null}

                  {brandTag === 'osw' ? isMobileView ? <PrintAndSocials includeTopMargin invertColors /> : null : null}
                </div>
              </div>
              <div className="print-about-wine-osw">
                <div className="col-sm-4 col-xs-12 text-center img-block bottle-image">
                  <BottleZoom
                    image={'/images/us/en/product/' + product.itemCode + '.png'}
                    imgWidth="39"
                    imgHeight="230"
                    itemCode={product.itemCode}
                  />
                </div>
                <div className="col-sm-8 col-xs-12 wine-details">
                  <h2 className="wine-detail">
                    <strong>About This Wine</strong>
                  </h2>
                  <div className="wineDetailsWrapper">
                    <div className="wine-details-icons-container">
                      <div className="col-md-12 col-xs-12 col-sm-12 no-pad first-section row1">
                        {product?.styleName && (
                          <BeyondLabelItem
                            className={`preview-attributes-row ${
                              brandTag.toLowerCase() === 'osw' ? 'col-md-4' : 'col-md-6'
                            }`}
                          >
                            <Icons.WineStyle />
                            <span>{product.styleName}</span>
                          </BeyondLabelItem>
                        )}

                        {product?.countryName && (
                          <BeyondLabelItem
                            className={`preview-attributes-row ${
                              brandTag.toLowerCase() === 'osw' ? 'col-md-4' : 'col-md-6'
                            } ${indexOfProductCountry % 2 !== 0 ? 'include-right-margin' : ''}`}
                          >
                            <Icons.Country />
                            <span>{product.countryName}</span>
                          </BeyondLabelItem>
                        )}

                        {product?.grapeName && (
                          <BeyondLabelItem
                            className={`preview-attributes-row ${
                              brandTag.toLowerCase() === 'osw' ? 'col-md-4' : 'col-md-6'
                            } ${indexOfProductGrape % 2 !== 0 ? 'include-right-margin' : ''}`}
                          >
                            <Icons.Grape />
                            <span>{product.grapeName}</span>
                          </BeyondLabelItem>
                        )}

                        {product?.alcoholPercent && (
                          <BeyondLabelItem
                            className={`preview-attributes-row ${
                              brandTag.toLowerCase() === 'osw' ? 'col-md-4' : 'col-md-6'
                            } ${indexOfProductAlcohol % 2 !== 0 ? 'include-right-margin' : ''}`}
                          >
                            <Icons.Alcohol />
                            <span>{product.alcoholPercent} %</span>
                          </BeyondLabelItem>
                        )}

                        {product.drinkCharacteristics?.organic && (
                          <BeyondLabelItem
                            className={`preview-attributes-row ${
                              brandTag.toLowerCase() === 'osw' ? 'col-md-4' : 'col-md-6'
                            } ${indexOfProductOrganic % 2 !== 0 ? 'include-right-margin' : ''}`}
                          >
                            <Icons.Organic />
                            <span>Organic</span>
                          </BeyondLabelItem>
                        )}

                        {product?.bottleSize && (
                          <BeyondLabelItem
                            className={`preview-attributes-row ${
                              brandTag.toLowerCase() === 'osw' ? 'col-md-4' : 'col-md-6'
                            } ${indexOfProductBottleSize % 2 !== 0 ? 'include-right-margin' : ''}`}
                          >
                            <Icons.Bottle />
                            <span>{product.bottleSize} ml</span>
                          </BeyondLabelItem>
                        )}

                        {product?.vintage && (
                          <BeyondLabelItem
                            className={`preview-attributes-row ${
                              brandTag.toLowerCase() === 'osw' ? 'col-md-4' : 'col-md-6'
                            } ${indexOfProductVintage % 2 !== 0 ? 'include-right-margin' : ''}`}
                          >
                            <Icons.Calendar />
                            <span>{product.vintage}</span>
                          </BeyondLabelItem>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12 col-xs-12 col-sm-12 no-pad first-section row1">
                      {!mixedCaseState.isPrepackItemCode && (
                        <>
                          <FoodPairings
                            foodPairings={mixedCaseState.foodPairings}
                            itemCode={product.itemCode}
                            productDetails={product}
                            activeSection={'Food Pairings'}
                            isMixed={false}
                            title={'Wine Food Pairings'}
                          />
                        </>
                      )}
                    </div>
                    <div className="col-md-12 flavorProfilesContainer">
                      {flavorProfile && (
                        <>
                          <FlavorProfiles
                            itemCode={product.itemCode}
                            activeSection={'Flavor Profiles'}
                            flavorProfile={flavorProfile}
                            title={'Wine Flavor Profile'}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12  osw-col">
                <div className="tab-component hr-line" />
                <DescriptionTab
                  productDetails={product}
                  tabName="About This Wine"
                  gaCategory={gaCategory}
                  gaAction={'Product_Details'}
                  descriptionType={'long'}
                />
              </div>
              {product?.tastingNotes?.mapImageFile ? (
                <div className="col-xs-12 tasting-notes-image-section">
                  <div className="no-pad text-center">
                    <div className="quote-section">
                      <h2 className="bottle-quote">{getQuote('accoladeDescription')}</h2>
                      <span className="bottle-quote-source">
                        {getQuote('accoladePerson')}
                        <br />
                        {getQuote('accoladeNameText')}
                      </span>
                    </div>
                  </div>
                  <div className="image-section">
                    <img
                      src={`${brandUrl}/images/uk/en/law/tastingnote/map/${product?.tastingNotes?.mapImageFile}.jpg`}
                      className="img-responsive js-default-tasting-note-image-handler"
                      alt="Map showing California"
                      onError={e => {
                        e.target.src = `${brandUrl}/images/uk/en/law/tastingnote/map/${product?.tastingNotes?.mapImageFile}.webp`;
                      }}
                    />
                  </div>
                  <div className="image-section text-right">
                    <img
                      src={`${brandUrl}/images/uk/en/law/tastingnote/information/${product?.tastingNotes?.otherImageFile}.jpg`}
                      className="img-responsive js-default-tasting-note-image-handler"
                      alt="Tasting note information"
                      onError={e => {
                        e.target.src = `${brandUrl}/images/uk/en/law/tastingnote/information/${product?.tastingNotes?.otherImageFile}.webp`;
                      }}
                    />
                  </div>
                </div>
              ) : null}
              <div className="col-xs-12">&nbsp;</div>
            </TastingNotesContainer>
          </>
        )}
      </div>
    </StyledContainer>
  );
};

/*
  Prop Types
 */
BeyondTheLabelMixed.propTypes = {
  itemCode: PropTypes.string,
};

export { BeyondTheLabelMixed };
